import styled, { css } from 'styled-components';
import { shade } from 'polished';

export interface ButtonAtributesProps {
  buttonType?: 'success' | 'warning' | 'info' | 'primary' | 'error' | 'outline' | 'disabled';
  borderColor?: string;
  textColor?: string;
  textSize?: string;
  marginLeft?: string;
  background?: string;
  textColorHover?: string;
  disableWitdthfixed?: boolean;
  borderColorHover?: string;
  padding?: string;
}

export const Root = styled.div<ButtonAtributesProps>`
  border-radius: 8px;
  width: 100%;

  transition: background-color 0.2s;
  background: #0d9e25;
  &:hover {
    background: ${shade(0.2, '#0d9e25')};
    border-radius: 8px;
  }

  ${props =>
    props.buttonType === 'success' &&
    css`
      background: #0d9e25;
      &:hover {
        background: ${shade(0.2, '#0d9e25')};
        border-radius: 8px;
      }
    `}

  ${props =>
    props.buttonType === 'warning' &&
    css`
      background: #f3ee0f;
      &:hover {
        background: ${shade(0.2, '#f3ee0f')};
        border-radius: 8px;
      }
    `}

  ${props =>
    props.buttonType === 'info' &&
    css`
      background: #4796ef;
      &:hover {
        background: ${shade(0.2, '#4796ef')};
        border-radius: 8px;
      }
    `}

  ${props =>
    props.buttonType === 'primary' &&
    css`
      background: var(--primary);
      &:hover {
        background: var(--primary_light);
        border-radius: 8px;
      }
    `}

  ${props =>
    props.buttonType === 'error' &&
    css`
      background: #f30f0f;
      &:hover {
        background: ${shade(0.2, '#f30f0f')};
        border-radius: 8px;
      }
    `}

  ${props =>
    props.buttonType === 'outline' &&
    css`
    background: ${props.background ? props.background : 'transparent'};
    width: ${props.disableWitdthfixed ? '100%' : '130px'};
    ${props.padding ?
     css`padding: ${props.padding};` : 
     css`height: 30px;`
    }
    border: 1px solid ${props.borderColor};
    border-radius: 8px;
    transition:all 0.6s ease;
    cursor: pointer;
    color: ${props.textColor ? props.textColor : '#000'};
    text-align: center;
    button {
      width: 100%;
    }

    :hover{
      background-color: ${props.borderColor};
      border: 1px solid ${props.borderColorHover ? props.borderColorHover : props.borderColor};
      border-radius: 8px;
        color: ${props.textColorHover ? props.textColorHover : '#FFF'};
    }
    `}

  ${props =>
    props.buttonType === 'disabled' &&
    css`
      background: #0d9e25;
      opacity: 0.7;
      border: 1px solid #0d9e25;
      color: ${props.textColor};
      cursor: no-drop;
      &:hover {
        background: ${shade(0.2, '#0d9e25')};

      }
    `}

  ${props =>
    props.marginLeft &&
    css`
      margin-left: ${props.marginLeft};
    `}
`;

export const Container = styled.button<ButtonAtributesProps>`
  display: flex;
  justify-content: space-around;
  align-items: center;

  border: 0;
  padding: 0 16px;
  width: 100%;
  height: 56px;
  font-weight: 500;

  cursor: pointer;

  ${props =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${props =>
    props.textSize &&
    css`
      font-size: ${props.textSize};
    `}

    ${props =>
    props.buttonType === 'disabled' &&
    css`
      background: #ccc;
      opacity: 0.7;
      border: 1px solid #ccc;
      color: ${props.textColor};
      cursor: no-drop;
      &:hover {
        background: ${shade(0.2, '#ccc')};

      }
    `}

    ${props =>
      props.buttonType === 'outline' &&
      css`
      width: ${props.disableWitdthfixed ? '100%' : '130px'};
      height: 30px;
      :hover{
        color: ${props.textColorHover ? props.textColorHover : '#FFF'};
      }
      `}
`;

export const ContainerIcone = styled.div``;
